import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import IfmsButton from './IfmsButton';

function GreenButtonInputExcel({
  children = undefined,
  ...other
}: {
  children: React.ReactNode | string,
  [x: string]: any,
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { onClick, handleFile, isText, isBlue, isPrimary,  
    //...remainingProps
   } = other;

  const baseClass = !other.notsetbackcolorwhenfocus ? 'ifms-primary-button' : 'ifms-primary-button b';
  async function handleClick() {
    if(onClick){
      if(!await onClick()) return;
    }
    if (inputRef && inputRef.current)
      inputRef.current.click();
  }
  function handleChangeUpload(e: any) {
    handleFile(e);
  }

  return (
    <>
      <IfmsButton {...other} size="regular" baseClass= {isPrimary ? baseClass : (isBlue ? "ifms-secondary-button" : "ifms-green-button")} onClick={() => { handleClick() }}>
        {children}
      </IfmsButton>
      <input type='file' accept= {isText ? '.txt' : '.xls, .xlsx'} ref={inputRef} style={{ display: 'none' }} onChange={e => handleChangeUpload(e)} />
    </>
  );
}

GreenButtonInputExcel.defaultProps = {
};

GreenButtonInputExcel.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large']),
};

export default React.memo(GreenButtonInputExcel);

